import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login, loginWithPassword } = useAuth();
  const navigate = useNavigate();
  const [showAdmin, setShowAdmin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submitAdmin = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await loginWithPassword(email.trim(), password);
      toast.success("Bienvenido al panel de administración.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo iniciar sesión.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="bg-white rounded-2xl border border-slate-200 p-10 max-w-md w-full text-center shadow-sm">
        <img src="/favicon-512.png" alt="2Voto" className="w-16 h-16 rounded-2xl mx-auto mb-5" />
        <h1 className="font-heading font-black text-2xl text-slate-900 mb-2">Crea tu cuenta verificada</h1>
        <p className="text-slate-600 text-sm mb-8">Necesitas una cuenta verificada para votar en consultas, firmar peticiones y dar seguimiento a temas. Un voto por cuenta.</p>
        <GoogleButton onClick={login} />
        <p className="text-xs text-slate-400 mt-6">Al continuar aceptas los términos de uso y la política de privacidad de 2Voto.</p>

        <div className="mt-8 pt-6 border-t border-slate-100">
          {!showAdmin ? (
            <button onClick={() => setShowAdmin(true)} data-testid="admin-login-toggle"
              className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors">
              <Lock className="w-4 h-4" /> Acceso de administrador
            </button>
          ) : (
            <form onSubmit={submitAdmin} className="text-left space-y-3" data-testid="admin-login-form">
              <div className="flex items-center gap-2 text-slate-700 font-semibold text-sm mb-1">
                <ShieldCheck className="w-4 h-4 text-cyan-500" /> Acceso de administrador
              </div>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="admin-email" placeholder="correo@ejemplo.com"
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-cyan-500" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="admin-password" placeholder="Contraseña"
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-cyan-500" />
              <button type="submit" disabled={busy} data-testid="admin-login-submit"
                className="w-full bg-slate-900 text-white font-semibold px-6 py-2.5 rounded-lg hover:bg-slate-800 transition-colors disabled:opacity-60">
                {busy ? "Entrando…" : "Entrar"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
